import { CircularProgress, Paper, Typography } from "@mui/material";
import axios from "axios";
import * as React from "react";
import { Chart } from "react-google-charts";
import { Config } from "../../../../config/config";
import { Helpers } from "../../../../utils/helpers";
import { ChatMessagesAnalyticsProps, ChatMessagesAnalyticsState } from "./types/chatMessages.types";

export class ChatMessagesAnalytics extends React.Component<ChatMessagesAnalyticsProps, ChatMessagesAnalyticsState> {

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            haveError: false,
            messagesPerDay: [],
            // Cache date range for latest request to not call multiple request with same date
            startDate: new Date(),
            endDate: new Date(),
        };
    }

    componentDidMount() {
        this.fetchData(this.props.dateRange.startDate, this.props.dateRange.endDate);
    }

    componentWillReceiveProps(props) {
        if (
            this.state.startDate.getTime() !== props.dateRange.startDate.getTime() ||
            this.state.endDate.getTime() !== props.dateRange.endDate.getTime()
        ) {
            // Fetch new data only when receiving new date range
            this.fetchData(props.dateRange.startDate, props.dateRange.endDate);
        }
    }

    fetchData = async (startDate: Date | undefined, endDate: Date | undefined) => {
        try {
            this.setState({ loaded: false, haveError: false });
            const userId = this.props.playerId;
            const searchStartDate = startDate || new Date();
            const searchEndDate = endDate || new Date();

            const response = await axios.get(`${Config.getInstance.apiUrl}/api/user/${userId}/analytics/chat_messages`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                    startDate: searchStartDate.getTime(),
                    endDate: searchEndDate.getTime(),
                },
            });

            this.setState({
                loaded: true,
                haveError: false,
                messagesPerDay: response.data.messages_per_day,
                startDate: searchStartDate,
                endDate: searchEndDate,
            });
        } catch (error) {
            this.setState({ haveError: true, loaded: true });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ float: "left", width: "50%", paddingRight: 10, paddingBottom: 20 }}>
                    <Paper style={{ height: "300px" }} className="center--content" elevation={0}>
                        {!this.state.loaded && <CircularProgress/>}
                        {this.state.loaded && this.state.haveError && <Typography variant="h3" gutterBottom>
                            Error
                        </Typography>}

                        {this.state.loaded && !this.state.haveError &&
                            <Chart
                                loader={<div>Loading Chart</div>}
                                width={"100%"}
                                height={"300px"}
                                chartType="ComboChart"
                                className="chart-root"
                                columns={[
                                    {
                                        type: "string",
                                        label: "Date",
                                    },
                                    {
                                        type: "number",
                                        label: "Global",
                                    },
                                    {
                                        type: "number",
                                        label: "Alliance",
                                    },
                                ]}
                                rows={this.state.messagesPerDay}
                                options={{
                                    title: "Chat messages per day",
                                    vAxis: { title: "Messages" },
                                    seriesType: "bars",
                                    legend: { position: "bottom", maxLines: 3 },
                                }}
                                legendToggle
                            />
                        }
                    </Paper>
                </div>
            </React.Fragment>
        );
    }
}
